/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ConditionOperator = {
    Equals: 'Equals',
    In: 'In',
    NotIn: 'NotIn',
    Between: 'Between',
    Gte: 'Gte',
    Lte: 'Lte',
    Matches: 'Matches'
} as const;
export type ConditionOperator = typeof ConditionOperator[keyof typeof ConditionOperator];

